<pagination-infinite-scroll (scrolled)="loadMore()">
  <table>
    <thead>
      <tr>
        <th class="col-arrow"></th>
        <th class="col-date">{{ "LABELS.DATE" | translate }}</th>
        <th *ngIf="this.companies?.length > 1" class="col-company">
          {{ "LABELS.IMPORTER_OF_RECORD" | translate }}
        </th>
        <th class="col-reference-number">{{ "LABELS.REF_N" | translate }}</th>
        <th class="col-service" colspan="2">
          {{ "LABELS.SERVICE" | translate }}
        </th>
        <th class="col-total">{{ "LABELS.TOTAL" | translate }}</th>
        <th class="col-method"></th>
        <th class="col-status">{{ "LABELS.STATUS" | translate }}</th>
        <th class="col-invoice-number">{{ "LABELS.INVOICE" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="!(total$ | async)">
        <tr>
          <td colspan="10">
            <div>
              {{ "LABELS.EMPTY_LIST" | translate }}
            </div>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="billList$ | async as billList">
        <ng-template ngFor [ngForOf]="billList" let-bill>
          <tr class="row-bill cursor-pointer" (click)="openFlags.set(bill.id, openFlags.has(bill.id) ? !openFlags.get(bill.id) : true)">
            <td class="col-arrow">
              <div class="icon-open-container">
                <icon-toggle-open-close [open]="openFlags.has(bill.id) && openFlags.get(bill.id)"></icon-toggle-open-close>
              </div>
            </td>
            <td
              class="col-date"
              [attr.data-label]="'LABELS.DATE' | translate"
              [title]="getBillCreatedDate(bill) ? (getBillCreatedDate(bill) | date : formatDateTime) : ''"
            >
              <div>
                {{ getBillCreatedDate(bill) ? (getBillCreatedDate(bill) | date : formatDateTime) : "" }}
              </div>
            </td>
            <td
              *ngIf="this.companies?.length > 1"
              class="col-company"
              [attr.data-label]="'LABELS.IMPORTER_OF_RECORD' | translate"
              [title]="bill.company?.name || ''"
            >
              <span *ngIf="!!bill?.company?.name">{{ bill?.company?.name }}</span>
            </td>
            <td
              class="col-reference-number"
              [attr.data-label]="'LABELS.REF_N' | translate"
              [title]="bill?.items?.[0]?.referenceNumber || ''"
            >
              <ng-template [ngIf]="bill.providerType === enumCompanyPaymentType.INSTANT || bill.isMirrored">
                <a
                  *ngIf="isReferenceNumberRedirectable(bill?.items?.[0]?.referenceNumber || ''); else billItemsReferenceNumberText"
                  class="link"
                  (click)="redirect((bill?.items?.[0]?.referenceNumber || ''), (bill?.company?.id || bill?.items?.[0]?.companyId), $event)"
                >
                  {{ bill?.items?.[0]?.referenceNumber }}
                </a>
                <ng-template #billItemsReferenceNumberText>
                  {{ bill?.items?.[0]?.referenceNumber }}
                </ng-template>
              </ng-template>
              <ng-template [ngIf]="bill.providerType === enumCompanyPaymentType.MONTHLY && !bill.isMirrored">
                {{ bill.timestamp | date : formatMonthDateTime }}
              </ng-template>
            </td>
            <td
              class="col-service"
              [ngClass]="{
                open: openFlags.has(bill.id) && openFlags.get(bill.id)
              }"
              colspan="2"
              [attr.data-label]="'LABELS.SERVICE' | translate"
              [title]="getProductCodeTranslationName(bill?.items[0]) | translate"
            >
              <div>
                {{ getProductCodeTranslationName(bill?.items[0]) | translate }}
              </div>
            </td>
            <td class="col-total total" [attr.data-label]="'LABELS.TOTAL' | translate">
              <ng-template [ngIf]="!bill.open || (this.isTablet$ | async)">
                {{ totalForBill(bill, true) | currency }}
              </ng-template>
            </td>
            <td class="col-method" [attr.data-label]="'LABELS.METHOD' | translate">
              <div class="payment-method-icon">
                <img
                  class="payment-method-icon__img"
                  [src]="getPaymentMethodPropertyValue(bill?.paymentCodeId, 'icon')"
                  nz-popover
                  nzPopoverOverlayClassName="tooltip-sm"
                  nzPopoverTrigger="hover"
                  [nzPopoverContent]="getPaymentMethodPropertyValue(bill?.paymentCodeId, 'name')"
                />
              </div>
            </td>
            <td
              class="col-status"
              [attr.data-label]="'LABELS.STATUS' | translate"
              [title]="'PAYMENT_STATE.' + enumPaymentState[bill?.state] | translate | uppercase"
            >
              <span [class]="'state-badge ' + getPaymentStateBadgeClass(bill?.state)">
                <img alt="state indicator" [src]="getPaymentStateIconPath(bill?.state)" *ngIf="!!getPaymentStateIconPath(bill?.state)" />
                {{ getPaymentStateTranslationText(bill?.state, bill?.providerType) | translate | uppercase }}
              </span>
            </td>
            <td class="col-invoice-number" [attr.data-label]="'LABELS.INVOICE' | translate">
              <div class="invoice-number-wrapper" *ngIf="bill?.invoiceDocumentNumber">
                {{ bill?.invoiceDocumentNumber }}
                <div
                  class="invoice-download-button"
                  [ngClass]="{ disabled: !bill?.isInvoiceDocumentDownloaded }"
                  (click)="onDownloadInvoice($event, bill?.id, bill?.invoiceId, bill?.isInvoiceDocumentDownloaded)"
                >
                  <img class="invoice-download-button__icon" src="assets/icons/icon_download_gray_md.svg" alt="download" />
                </div>
              </div>
            </td>
          </tr>
          <ng-template ngFor let-item let-i="index" [ngForOf]="bill.items">
            <tr class="row-bill-item" [ngClass]="{ 'd-none': !(openFlags.has(bill.id) && openFlags.get(bill.id)) }">
              <td class="col-date" [colSpan]="this.companies?.length > 1 ? 3 : 2"></td>
              <td class="col-reference-number" [attr.data-label]="'LABELS.REF_N' | translate" [title]="item.referenceNumber || ''">
                <a
                  *ngIf="isReferenceNumberRedirectable(item?.referenceNumber || ''); else itemReferenceNumberText"
                  class="link"
                  (click)="redirect(item?.referenceNumber || '', item?.companyId, $event)"
                >
                  {{ item.referenceNumber }}
                </a>
                <ng-template #itemReferenceNumberText>
                  {{ item.referenceNumber }}
                </ng-template>
              </td>
              <td class="col-service-item" [ngClass]="{ 'col-service': i === 0 }" [attr.data-label]="'LABELS.DESCRIPTION' | translate">
                <span>
                  {{ item.description }}
                </span>
              </td>
              <td class="col-notes" [attr.data-label]="'LABELS.NOTES' | translate">
                <div class="d-flex justify-content-between align-items-center">
                  <span>{{ item.notes }}</span>
                  <span class="quantity-number">{{ item.quantity > 1 ? item.quantity : " " }}</span>
                  <span class="quantity-number">
                    {{ item?.internalQuantities?.quantity }} {{ billItemUnitName(item?.internalQuantities?.unit) | translate }}
                  </span>
                </div>
              </td>
              <td class="col-total total" [colSpan]="this.companies?.length > 1 ? 4 : 3" [attr.data-label]="'LABELS.AMOUNT' | translate">
                {{ item.price | currency }}
              </td>
              <td class="col-invoice-number"></td>
            </tr>

            <!--Partial Refund Bill Item Rows-->
            <ng-container *ngIf="!isHasRefundInvoice(bill)">
              <tr
                *ngFor="let refund of getBillItemBillRefunds(bill, item)"
                class="row-bill-item"
                [ngClass]="{ 'd-none': !(openFlags.has(bill.id) && openFlags.get(bill.id)) }"
              >
                <td class="col-arrow"></td>
                <td class="col-date" [colSpan]="this.companies?.length > 1 ? 2 : 1">
                  {{ (refund?.timestamp | date : formatDateTime) || "" }}
                </td>
                <td class="col-reference-number"></td>
                <td class="col-service-item refund" [attr.data-label]="'LABELS.DESCRIPTION' | translate">
                  <span>
                    {{ item.description }}
                  </span>
                </td>
                <td class="col-notes" [attr.data-label]="'LABELS.NOTES' | translate">
                  <ng-container>
                    <div class="d-flex justify-content-end align-items-center">
                      <span class="quantity-number">
                        {{ item.quantity > 1 ? "-" + getRefundBillItemRefundItem(refund, item)?.quantity : "" }}
                      </span>
                    </div>
                  </ng-container>
                </td>
                <td class="col-total refund" [colSpan]="3" [attr.data-label]="'LABELS.AMOUNT' | translate">
                  <span>
                    {{ getRefundBillItemRefundItem(refund, item)?.amount ?? item.price | currency }}
                  </span>
                </td>
                <td class="col-invoice-number">
                  <div class="invoice-number-wrapper">
                    {{ refund?.invoiceDocumentNumber }}
                    <div
                      *ngIf="refund?.invoiceDocumentNumber"
                      class="invoice-download-button small"
                      [ngClass]="{ disabled: !refund?.isInvoiceDocumentDownloaded }"
                      (click)="onDownloadInvoice($event, bill?.id, refund?.invoiceDocumentId, refund?.isInvoiceDocumentDownloaded)"
                    >
                      <img class="invoice-download-button__icon" src="assets/icons/icon_download_gray_md.svg" alt="download" />
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-template>

          <!--Full refund row-->
          <tr
            *ngIf="isHasRefundInvoice(bill)"
            class="row-bill-item"
            [ngClass]="{ 'd-none': !(openFlags.has(bill.id) && openFlags.get(bill.id)) }"
          >
            <td class="col-arrow"></td>
            <td class="col-date" [colSpan]="this.companies?.length > 1 ? 2 : 1">{{ bill?.refundTimestamp | date : formatDateTime }}</td>
            <td class="col-reference-number"></td>
            <td
              class="col-service-item"
              colSpan="2"
              [ngClass]="{ 'col-service': i === 0 }"
              [attr.data-label]="'LABELS.DESCRIPTION' | translate"
            >
              {{ "BUTTON.FULL_REFUND" | translate }}
            </td>
            <td class="col-total refund" colSpan="3">
              <span>{{ totalForBill(bill) | currency }}</span>
            </td>
            <td class="col-invoice-number" colSpan="2">
              <div class="invoice-number-wrapper">
                {{ bill?.refundInvoiceDocumentNumber }}
                <div
                  class="invoice-download-button small"
                  [ngClass]="{ disabled: !bill?.isRefundInvoiceDocumentDownloaded }"
                  (click)="onDownloadInvoice($event, bill?.id, bill?.refundInvoiceId, bill?.isRefundInvoiceDocumentDownloaded)"
                >
                  <img class="invoice-download-button__icon" src="assets/icons/icon_download_gray_md.svg" alt="download" />
                </div>
              </div>
            </td>
          </tr>

          <tr
            *ngIf="!(this.isTablet$ | async)"
            class="row-bill-footer"
            [ngClass]="{ 'd-none': !(openFlags.has(bill.id) && openFlags.get(bill.id)) }"
          >
            <td class="col-transaction-id" [colSpan]="10">
              <span class="mr-4">
                {{ "LABELS.TRANSACTION_ID" | translate }}:
                <b>{{ bill.providerTransactionId }}</b>
              </span>
            </td>
          </tr>
        </ng-template>
      </ng-container>
      <tr *ngIf="isLoading$ | async" class="scrolling-container">
        <th colspan="10">
          <loading-spinner [show]="true"></loading-spinner>
        </th>
      </tr>
    </tbody>
  </table>
</pagination-infinite-scroll>

<a #invoiceDownloadLink class="d-none" download></a>
